import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Car, Calendar, User } from 'lucide-react';

// Navegação oficial do cliente (mobile). Aba ativa derivada da URL (fonte de verdade).
export const NAV_ITEMS = [
  { slug: 'inicio', label: 'Início', icon: Home, to: '/client/dashboard' },
  { slug: 'lavajatos', label: 'Lava-jatos', icon: Car, to: '/client/providers' },
  { slug: 'agendamentos', label: 'Agendamentos', icon: Calendar, to: '/client/appointments' },
  { slug: 'perfil', label: 'Perfil', icon: User, to: '/client/profile' },
];

// Rotas onde a barra deve aparecer (SOMENTE estas 4).
export const BOTTOM_NAV_ROUTES = NAV_ITEMS.map((i) => i.to);

export const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Só renderiza nas 4 rotas autorizadas (oculta em auth/onboarding/checkout/schedule/etc.)
  if (!BOTTOM_NAV_ROUTES.includes(location.pathname)) return null;

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 shadow-[0_-1px_8px_rgba(0,0,0,0.04)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="mobile-bottom-nav"
    >
      <div className="grid grid-cols-4">
        {NAV_ITEMS.map(({ slug, label, icon: Icon, to }) => {
          const active = location.pathname === to;
          return (
            <button
              key={to}
              type="button"
              onClick={() => navigate(to)}
              aria-current={active ? 'page' : undefined}
              className={`flex flex-col items-center justify-center gap-0.5 py-2 min-h-[56px] transition-colors ${
                active ? 'text-primary' : 'text-slate-500 hover:text-slate-700'
              }`}
              data-testid={`bottomnav-${slug}`}
            >
              <Icon className="w-5 h-5" strokeWidth={active ? 2.4 : 2} />
              <span className={`text-[11px] leading-none ${active ? 'font-semibold' : 'font-medium'}`}>{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
